import { Measurement } from "modules/common/components/Alarms/constants";
import { payloadSchema } from "modules/common/components/Alarms/Form/utils/schemas/AlarmPayloadSchema";
import { SelectedCountyStation, IStationAlarm } from "modules/common/components/Alarms/types/AlarmModels";
import { StationType } from "modules/common/components/Alarms/types/AlarmsForm";

export const buildBaseAlarmPayload = (
    selectedMeasurementTypes: Measurement[],
    selectedCountyStations: SelectedCountyStation[],
    groupName: string,
    existingAlarmGroup?: { stationAlarms: any[] }
) => {
    if (!selectedCountyStations.length) {
        return {
            payload: null,
            errorMessage: "Mora biti odabrana barem jedna stanica.",
        };
    }

    if (!selectedMeasurementTypes.length) {
        return {
            payload: null,
            errorMessage: "Mora biti odabrana barem jedna vrsta mjerenja.",
        };
    }

    const alarms: IStationAlarm[] = [];

    for (const station of selectedCountyStations) {
        const stationAlarms = selectedMeasurementTypes.map((smt: Measurement) => {
            const metosStationId =
                station.stationType === StationType.Metos ? station.stationId : undefined;
            const pinovaStationId =
                station.stationType === StationType.Pinova ? station.stationId : undefined;

            const existingAlarmId = existingAlarmGroup?.stationAlarms?.find(existing => 
                ((existing.metosStationId === metosStationId && metosStationId !== undefined) ||
                 (existing.pinovaStationId === pinovaStationId && pinovaStationId !== undefined)) &&
                existing.measurementType === smt.measurementType
            )?.id;

            const alarm: IStationAlarm = {
                id: existingAlarmId,
                measurementType: smt.measurementType,
                measurementUnit: smt.measurementUnit,
                type: smt.type,
                amount: smt.amount,
                lookbackDays: smt.lookbackDays,
                valueRange: smt.valueRange,
                metosStationId,
                pinovaStationId,
                phenophaseId: smt.phenophaseId,
            };

            return alarm;
        });

        alarms.push(...stationAlarms);
    }

    const result = payloadSchema.safeParse({
        groupName,
        alarms,
    });

    if (!result.success) {
        const allMessages = result.error.issues.map(i => i.message);
        const uniqueMessages = [...new Set(allMessages)];
        const errorMessage = uniqueMessages.join(", ");

        return { payload: null, errorMessage };
    }

    return {
        payload: result.data,
        errors: null,
    };
};
